import { Inject, Injectable } from "@angular/core";
import { JwtHttpClientService } from "../http/jwt-http-client.service";
import { Observable } from "rxjs";
import { AbstractHttpService } from "../http/abstract-http.service";
import { AuthService } from "../auth/auth.service";
import { ConfigurationServiceConstants } from "../configuration/configuration-service-constants";
import { EntityData } from "..";
export class LogMessage {
    constructor(date, user, message, context, error) {
        this.date = date;
        this.user = user;
        this.message = message;
        this.context = context;
        this.error = error;
        // Convert an EntityData object to a simple object to avoid circular references when calling JSON.stringify
        if (this.context instanceof EntityData) {
            this.context = JSON.parse(context.toJSONString());
        }
    }
}
/**
 * Allow the client to log messages in the server
 */
export class ServerLoggingService extends AbstractHttpService {
    /**
     *
     * @param serverHttp Server HTTP Service
     * @param authService Auth Service
     * @param application Application name used for context lookup
     */
    constructor(serverHttp, authService, application) {
        super();
        this.serverHttp = serverHttp;
        this.authService = authService;
        this.application = application;
        this.pendingLogMessages = [];
    }
    log(message, context, error) {
        this.pendingLogMessages.push(new LogMessage(new Date(), this.authService.getLoggedInUserName(), message, context, error));
        if (!this.polling) {
            this.initNextPoll(ServerLoggingService.DELAY_SHORT);
        }
    }
    /**
     * Initialises the poll of the queue to fire at the specified delay. Only a single poll is performed
     * to ensure all operations are completed before setting up the next poll.
     * @param {number} delay
     */
    initNextPoll(delay) {
        this.polling = true;
        Observable.timer(delay).first().subscribe(() => this.processMessage());
    }
    processMessage() {
        if (this.pendingLogMessages.length == 0) {
            this.polling = false;
            return;
        }
        const logMessage = this.pendingLogMessages[0];
        let logJson;
        try {
            logJson = JSON.stringify(logMessage, null, "    ");
        }
        catch (error) {
            logMessage.context = "Cannot convert context to json";
            try {
                logJson = JSON.stringify(logMessage, null, "    ");
            }
            catch (error) {
                console.log("Cannot convert message to json");
                console.error(error);
                this.initNextPoll(ServerLoggingService.DELAY_ERROR);
                return;
            }
        }
        this.serverHttp.post(ServerLoggingService.URL_PREFIX, logJson).subscribe(() => {
            this.pendingLogMessages.shift();
            this.initNextPoll(ServerLoggingService.DELAY_SHORT);
        }, error => {
            console.log("Posting log message failed");
            console.error(error);
            this.initNextPoll(ServerLoggingService.DELAY_ERROR);
        });
    }
}
/**
 * Static URL prefix for all server side calls
 * @type {string}
 */
ServerLoggingService.URL_PREFIX = '/dataserver/logging/';
/**
 * Interval when there are connectivity issues
 */
ServerLoggingService.DELAY_ERROR = 10000;
/**
 * Poll interval when draining the queue
 */
ServerLoggingService.DELAY_SHORT = 100;
ServerLoggingService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ServerLoggingService.ctorParameters = () => [
    { type: JwtHttpClientService, },
    { type: AuthService, },
    { type: undefined, decorators: [{ type: Inject, args: [ConfigurationServiceConstants.APPLICATION_KEY,] },] },
];
//# sourceMappingURL=server-logging.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/logging/server-logging.service.js
// module id = 419
// module chunks = 1